import { Storage } from "aws-amplify";

export const uploadFileToS3 = async (
    file: File,
    s3Key: string,
    onProgress: (progress: number) => void
) => {
    try {
        const result = await Storage.put(s3Key, file, {
            progressCallback(progress) {
                const percentUploaded = Math.round((progress.loaded / progress.total) * 100);
                onProgress(percentUploaded);
            },
        });

        return { name: file.name, key: result.key };
    } catch (error) {
        console.error(`Error uploading file ${file.name}:`, error);

        throw error;
    }
};

export const updateArtifactDetails = async (updateArtifact, data, propertyId, alias, newImages) => {
    try {
        const updatedData = {
            artifactType: "REAL_PROPERTY",
            artifactId: propertyId,
            businessUseCase: "SMART",
            clientName: alias,
            updatedBy: alias,
            updatedArtifactDetails: {
                ...data.propertyDetails,
                propertyImages: newImages,
            },
        };

        return await updateArtifact(updatedData);
    } catch (error) {
        console.error("Error updating artifact details:", error);

        throw error;
    }
};

export const fetchPreSignedUrl = async (canopyS3Key: string) => {
    try {
        return await Storage.get(canopyS3Key, { expires: 3600 }); // URL expires in 1 hour
    } catch (error) {
        console.error(`Error fetching presigned URL for ${canopyS3Key}:`, error);

        return null;
    }
};

export const imageTypeMapping = {
    regionalMap: "Regional Map",
    locationMap: "Location Map",
    aerialMap: "Aerial Map",
    platMap: "Plat Map",
    propertyPlan: "Property Map",
    topographicMap: "Topographic Map",
    subjectPropertyPhotos: "Subject Property Photos",
    others: "Others",
};

export const getImageTypeLabel = (type: string): string => {
    return imageTypeMapping[type] || type;
};

export const handleDownloadAllImages = async (setLoading, galleryImages) => {
    setLoading(true);
    try {
        for (const image of galleryImages) {
            // Use the existing fetchPreSignedUrl function to get the URL
            const presignedUrl = await fetchPreSignedUrl(image.canopyS3Key);

            if (presignedUrl) {
                const response = await fetch(presignedUrl);
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = image.fileName || `image-${image.canopyS3Key.split("/").pop()}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                console.error(`Failed to get presigned URL for ${image.canopyS3Key}`);
            }
        }
    } catch (error) {
        console.error("Error downloading images:", error);
    }
    setLoading(false);
};
